module.exports = __webpack_public_path__ + "assets/a56df8adaf921b2fae93ebbb30085e98.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/randWilds/WolfHowl.mp3
 ** module id = 380
 ** module chunks = 0
 **/